import React from 'react';
import "./dashboard__type2.css"
import {BgHeartNiko, TriangleSign} from "../../../Assets/svg";
import numeric from "../../../utils/NumericFunction";
import utilsFunction from "../../../utils/utilsFunction";
import CommaSeparator from "../../../utils/CommaSeparator";
import {ReactTabulator} from "react-tabulator";
import TabulatorTableOptions from "../../../utils/TabulatorTableOptions";
import AdminCharts from "../../../Components/AdminReport/AdminChart/AdminChart";
import chart from "../../../Components/Chart";
import IconViewer from "../../../Assets/svg/IconViewer";
import axios from "axios";
import {toast} from "react-toastify";

const DashboardType2 = (props) => {
  const {dashboardComponentData} = props;
  //debugger
  dashboardComponentData?.table?.columns.forEach((v,indexForEach) => {
    //debugger
    v.hozAlign = "center"
    v.headerHozAlign = "center"
    // v.width = `${(100 / dashboardComponentData.table.columns.length)+1}%`
    // (index===0) && (v.width=150)
    if(indexForEach===0){
      v.width=150
    }
    if(indexForEach===1){
      v.width=350
    }
    if(indexForEach===2){
      v.width=300
    }
    if(indexForEach===3){
      v.width=300
    }


  })

  function logOutHandler() {
    let HOST = window.location.hostname === "localhost" ? "http://localhost/Git/Delsa/Frm" : "/Frm"
    const logOutRequest = axios({
      method: "post",
      url: `${HOST}/check_user/`,
      params: {logout: "logout"},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      localStorage.removeItem("token");
      sessionStorage.setItem("isAuth", false);
      window.location.reload();
    }).catch((error) => {
      localStorage.removeItem("token");
      sessionStorage.setItem("isAuth", false);
    });

    toast.promise(logOutRequest, {
      pending: "در حال خروج از حساب",
      success: "خروج با موفقیت ثبت شد",
      error: "ثبت خروج با مشکل مواجه شد",
    });

    console.log("logOutRequest");
  }

  return (<>
    {JSON.stringify(dashboardComponentData) === JSON.stringify({}) ? <>در حال بارگزاری</> : <>
      <div className={"dashboard__type2"}>
        <div className={"d-flex justify-content-between align-items-center"}>

          <div className={"mx-2 my-2"}>
            <div className={"text__color__like__black"}><TriangleSign/>
              <span className={"px-1"}> {dashboardComponentData.mainTitle}</span>
            </div>
          </div>
          <div className={"mx-2 my-2 d-flex"}>
            <a
              className={"text__color__white d-flex  align-items-center justify-content-center"}
              style={{
                width: 138,
                height: 36,
                fontSize: 14,
                background: '#2EB872',
                borderRadius: '10px',
                display: "block",
              }}
              href={dashboardComponentData.url}>{dashboardComponentData.site}</a>
            <div className="mx-2 my-2" onClick={logOutHandler}>
              <i className="fas fa-power-off"></i>
            </div>
          </div>

        </div>
        <hr/>
        <div className={"d-flex flex-wrap"}>
          <div className={" col-sm-12 col-md-9 "}>
            <div className={"text__color__white"} style={{

              display: 'grid',
              // 'grid-template-columns': 'repeat(4, 1fr)',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',

              gridGap: '10px',
            }}>
              {
                dashboardComponentData.panelData.map((v, index) =>
                  <div key={index} className="item__card__data position-relative">
                    <div className={"position-absolute"} style={{}}>
                      <IconViewer icon={v.icon} />
                    </div>
                    <div
                      className={"position-absolute"}
                      style={{left: 20, bottom: 10, fontSize: '10px'}}> {v.text}</div>
                    <div
                      className={"position-absolute"}
                      style={{left: 20, bottom: 30, fontSize: '24px',}}>{numeric.e2p(CommaSeparator(v.number))}
                    </div>
                  </div>
                )
              }
            </div>

            <div className={"mx-2 mt-5"}>
              <div className={"text__color__like__black"}><TriangleSign/>
                <span className={"px-1"}> {dashboardComponentData.table.tableTitle}</span>
              </div>
            </div>

            <div>
              <ReactTabulator
                columns={dashboardComponentData.table.columns}
                data={dashboardComponentData.table.data}
                // events={{rowClick: rowClickHandler}}
                options={TabulatorTableOptions.style4}
              />
            </div>


          </div>
          <div className={" col-sm-12 col-md-3 "}>

            <div className={"d-flex flex-column justify-content-around"}>
              {dashboardComponentData.chart.map((v, index) =>
                <div key={index + ""} className={" rounded pb-5 px-1"}
                >
                  <AdminCharts
                    type={v.type}
                    title={v.title}
                    options={v.options}
                    data={v.data}
                    // className={props.className}
                    // sum={sumOfData[i]}
                    hasBorder={false}
                    hasPrint={false}
                  />

                </div>
              )}

            </div>
          </div>

        </div>

      </div>
    </>}
  </>);
};

export default DashboardType2;
